function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "url(#paint0_linear_2899_11916)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 19,
  cy: 25,
  r: 5,
  fill: "#AA2E2C"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 45,
  cy: 25,
  r: 5,
  fill: "#AA2E2C"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44 51C39 49.9714 29 48.6857 20 51C20.9 48 24.44 42 31.4 42C40.1 42 43.1 47.1429 44 51Z",
  fill: "#AA2E2C"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_2899_11916",
  x1: 32,
  y1: 0,
  x2: 32,
  y2: 64,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8B91"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF565F"
})));

var Svg8Day = function Svg8Day(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg8Day, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/8day.7cf20451.svg";
export { ForwardRef as ReactComponent };